'use strict';
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/internals/use-symbol-as-uid.js
// module id = 275
// module chunks = 0